import {
    AppIdentifiers,
    AreaType,
    INavigationChannel,
    MessageBroker,
    PostLoginActionNameEnum,
    TriggerType,
} from '@sparkware/uc-sdk-core';
import {
    IOpenControlCenterPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { v4 as uuidv4 } from 'uuid';

const ModuleName = 'OpenControlCenterPostLoginAction';

export class OpenControlCenterPostLoginAction extends PostLoginActionBase {
    private readonly _navigationChannel: INavigationChannel;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.OpenControlCenterFull, ModuleName, state);
        this._navigationChannel = MessageBroker.getInstance().navigation;
    }

    protected override canExecute = (
        options?: IOpenControlCenterPostLoginOptions,
    ): Promise<boolean> => {
        const openControlCenterFullRequired = options?.enabled || false;
        return Promise.resolve(openControlCenterFullRequired);
    };

    protected override doAction = async (): Promise<void> => {
        this.clearOptions();
        this._navigationChannel.topics.performAction.publish(
            { publisher: ModuleName },
            {
                actionID: 'openControlCenterFull',
                correlationID: uuidv4(),
                launchInfo: {
                    appSpecificParameters: {
                        clientPlatform: 1,
                        source: AreaType.UD,
                    },
                    channel: {
                        area: AreaType.UD,
                        element: 'UD',
                        source: 'Unified Client',
                    },
                    trigger: TriggerType.userSelection,
                    businessCorrelationID: uuidv4(),
                    sourceAppID: AppIdentifiers.UnifiedClient,
                    sourceAppVersion: '0.0.0',
                },
                actionData: {},
            },
        );
        this.completeAction();
    };
}
